export default __webpack_public_path__ + "static/media/schumann.0c0e9ee3.png";